import React, { useState } from 'react'
import { Button, Typography, FormControlLabel, Stack, Switch, Divider } from '@mui/material'

function GroupStats(props) {
    const [displayPercent, setDisplayPercent] = useState(false);
    const switchDisplay = () => setDisplayPercent(!displayPercent);
  return (
    <Stack spacing={1} sx={{ml:2, py: 2}} justifyContent="flex-start" style={{height: "50%"}}>
        <Stack sx={{borderColor: "#f1f1f1", borderRadius: 1, boxShadow: 2, paddingBottom: 1}} style={{marginInline: "8%"}}>
          <Stack sx={{px: 1, py: 1, backgroundColor:'#2E2E2E', color: 'white', borderTopRightRadius: '3px', borderTopLeftRadius: '3px', alignItems: 'center'}}>
            <Typography variant='h5' style={{marginLeft: 4, marginTop: 2}}>Group Formation</Typography>
          </Stack>
          <Stack sx={{borderRadius: 1, alignItems: 'center'}}>
            <Typography variant='subtitle2' style={{marginLeft: 4, marginTop: 2}}>Sort Students:</Typography>
          </Stack>
          <Stack direction='row' spacing={1} sx={{px: 2, py: .5, borderRadius: 1, justifyContent:'center'}}>
            <Button size="small" onClick={props.handleRunAlgorithm} variant='contained' style={{maxWidth: "75%", width: "50%", backgroundColor: '#2E2E2E', fontSize: '12px'}}>
              Sort by Rankings
            </Button>
            <Button size="small" onClick={props.handleSortByFirstChoice} variant='contained' style={{maxWidth: "75%", width: "50%", backgroundColor: '#2E2E2E', fontSize: '12px'}}>
              Sort by 1st Choice
            </Button>
          </Stack>

          {
            props.stats['total projects'] > 0  && 
            <>
              <Stack sx={{borderRadius: 1, alignItems: 'center'}}>
                <Typography variant='subtitle2' style={{marginLeft: 4, marginTop: 2}}>Modify Output:</Typography>
              </Stack>
              <Stack direction='row' spacing={1} sx={{px: 2, py: .5, borderRadius: 1, justifyContent:'center'}}>
                <Button variant='contained' style={{maxWidth: "75%", width: "50%", backgroundColor: '#2E2E2E', fontSize: '12px'}} onClick={props.handleLockAll}>
                  Lock All Students
                </Button>
                <Button variant='contained' style={{maxWidth: "75%", width: "50%", backgroundColor: '#2E2E2E', fontSize: '12px'}} onClick={props.handleUnlockAll}>
                  Unlock All Students
                </Button>
              </Stack>
              
              <Stack sx={{borderRadius: 1, alignItems: 'center'}}>
                <Typography variant='subtitle2' style={{marginLeft: 4, marginTop: 2}}>Viewing Output:</Typography>
              </Stack>
              <Stack direction='row' spacing={1} sx={{px: 2, py: .5, borderRadius: 1, justifyContent:'center'}}>
                <Button variant='contained' style={{maxWidth: "75%", width: "50%", backgroundColor: '#2E2E2E', fontSize: '12px'}} onClick={props.handleExpandAll}>
                  Expand All Groups
                </Button>
                <Button variant='contained' style={{maxWidth: "75%", width: "50%", backgroundColor: '#2E2E2E', fontSize: '12px'}} onClick={props.handleCollapseAll}>
                  Collapse All Groups
                </Button>
              </Stack>
              <Stack direction='row' spacing={1} sx={{px: 2, py: .5, borderRadius: 1, justifyContent:'center'}}>
                <Button onClick={props.openSavedList} variant='contained' style={{maxWidth: "75%", width: "50%", backgroundColor: '#2E2E2E', fontSize: '12px'}}>
                  View Saved Outputs
                </Button>
                <Button onClick={props.openSaveModal} variant='contained' style={{maxWidth: "75%", width: "50%", backgroundColor: '#2E2E2E', fontSize: '12px'}}>
                  Save Outputs
                </Button>
              </Stack>

              <Stack sx={{borderRadius: 1, alignItems: 'center'}}>
                <Typography variant='subtitle2' style={{marginLeft: 4, marginTop: 2}}>Complete Group Formation:</Typography>
              </Stack>
              <Stack direction='row' spacing={2} sx={{px: 2, py: .5, borderRadius: 1, justifyContent:'center', paddingBottom: '20px'}}>
                <Button onClick={props.handleFinalizeGroups} variant='contained' style={{maxWidth: "100%", width: "100%", backgroundColor: '#2E2E2E', fontSize: '12px'}}>
                  Finalize Groups
                </Button>
              </Stack>
            </>
          }
        </Stack>

        <Stack sx={{px: 2, py: 1, border: 1, borderColor: "#f1f1f1", borderRadius: 2, boxShadow: 2}} style={{marginInline: "8%"}}>
          <Typography variant='subtitle2'>Total Students: {props.studentDetails.length}</Typography>
          <Typography variant='subtitle2'>Total Projects: {props.stats['total projects'] > 0 ? props.stats['total projects'] : <b>Displays on Algorithm run</b>}</Typography>
          <table >
            <tbody>
            {[...Array(10)].map((e, i) => 
              <tr key={i} style={{ borderTop: '1px solid black' }}>

                <td style={{ borderTop: '1px solid black' , borderRight: '1px solid black' }}>
                  <Typography key={i} variant='subtitle2'>
                    #{i + 1} choice:  
                  </Typography> 
                </td>
                <td style={{ borderTop: '1px solid black' }}>

                  <Typography key={i} variant='subtitle2'>
                    { displayPercent ?
                        (props.stats !== undefined ? (props.stats[i + 1] / props.studentDetails.length * 100).toFixed(1) +"%" : 0):
                        (props.stats !== undefined ? props.stats[i + 1] : 0)
                    }
                  </Typography> 
                </td>
              </tr>
            )}
            </tbody>
          </table>

          <FormControlLabel
            control={<Switch color="primary" />}
            label={displayPercent ? 'Switch to Numerical' : 'Switch to Percentage'}
            labelPlacement="bottom"
            onClick={switchDisplay}
          />
        </Stack>
      </Stack>
  )
}

export default GroupStats
